export enum LogUserPositionResponseAttributes {
    Message = 'Message',
    Code = 'Code',
    Result = 'Result',
}

export interface LogUserPositionResponse {
    ContextEnded?: boolean;
    [LogUserPositionResponseAttributes.Message]: string;
    [LogUserPositionResponseAttributes.Code]: number;
    [LogUserPositionResponseAttributes.Result]?: LogUserPositionResult;
}

export interface LogUserPositionResult {
    HistoryId?: number;
    HistoryOutcome?: 'Recorded' | 'Disabled' | 'Failed';
    // IsInProjectBoundary can be 0, 1, 2, null - 1 means out of bounds, 0 means in bounds , 2 means nomapping
    // null means no value(user is clocked out)
    IsInProjectBoundary: UserPositionResult | null;
}

export enum UserPositionResult {
  InBounds = 0,
  OutOfBounds = 1,
  NoMapping = 2
}
